import { useRef, type RefObject } from "react";

/**
 * Returns a ref that always holds the latest `value`, updated on every render.
 *
 * Mirroring a prop or callback into a ref for use inside stable callbacks
 * (e.g. event handlers, timers) does not need an Effect — assigning
 * `ref.current` during render is synchronous and always up to date by the
 * time anything reads it. Reach for this instead of writing a `useEffect`
 * that only does `ref.current = value`.
 */
export function useLatestRef<T>(value: T): RefObject<T> {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
